import integration from '../../integration';
import injectBrandingColors from '../helpers/inject-branding-colors';

const colorsInjector = () => (next) => (action) => {
  switch (action.type) {
    case integration.actionTypes.SET_INTEGRATION_SETTINGS: {
      const { branding } = action.payload.settings;

      if (branding && branding.colors) {
        injectBrandingColors(branding.colors);
      }

      next(action);
      break;
    }

    default:
      next(action);
  }
};

export default colorsInjector;
